// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const SellerTeamClient = registerClientReference(
    function() { throw new Error("Attempted to call SellerTeamClient() from the server but SellerTeamClient is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/web/src/app/(seller)/seller/team/seller-team-client.tsx",
    "SellerTeamClient",
);
